import axios from 'axios';
import config from 'commons-general/config/index.js';
import { HTTPService } from '@sm360/widget-commons-core-services';

import CookieService from 'commons-general/services/CookieService/CookieService.js';
import AccountService from 'commons-general/services/AccountService/AccountService.js';
import COOKIES from 'commons-general/constants/cookies.js';

import CONSTANT from 'commons-general/services/ProfileService/ProfileServiceConstant.js';

class ProfileService {
    constructor() {
        this.accountBasePath = `${config.endpoint.account}/accounts`;
        this.getLoggedAccountProfile = this.getLoggedAccountProfile.bind(this);
        this.fetchProfile = this.fetchProfile.bind(this);
        this.updateAccountProfile = this.updateAccountProfile.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
    }

    fetchProfile() {
        const accountToken = CookieService.getToken(COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

        return axios
            .get(`${this.accountBasePath}/profile`, {
                headers: {
                    'x-auth-token': accountToken,
                },
            })
            .then((response) => {
                if (!response || response.status === 204) {
                    return Promise.reject(
                        HTTPService.formatRejectResponse(CONSTANT.UNKNOW_ERROR_FETCHING_PROFILE, response)
                    );
                }

                this.profile = response.data;

                return Promise.resolve(this.profile);
            });
    }

    getLoggedAccountProfile() {
        if (!AccountService.isAuthenticated()) {
            return Promise.reject(HTTPService.formatRejectResponse('notAuthenticated'));
        }

        if (!this.profile) {
            return this.fetchProfile();
        }

        return Promise.resolve(this.profile);
    }

    updateAccountProfile(profile) {
        const accountToken = CookieService.getToken(COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

        return axios
            .put(`${this.accountBasePath}/profile`, profile, {
                headers: {
                    'x-auth-token': accountToken,
                },
            })
            .then((response) => {
                if (!response || response.status === 204) {
                    return Promise.reject(
                        HTTPService.formatRejectResponse('unknownErrorUpdatingAccountProfile', response)
                    );
                }
                this.profile = profile;
                return Promise.resolve(response);
            });
    }

    updatePassword(passwordForm) {
        if (!AccountService.isAuthenticated()) {
            return Promise.reject(HTTPService.formatRejectResponse('notAuthenticated'));
        }

        const accountToken = CookieService.getToken(COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

        return axios.put(`${this.accountBasePath}/updatePassword`, passwordForm, {
            headers: {
                'x-auth-token': accountToken,
            },
            transformResponse: [
                (data) => {
                    return data;
                },
            ],
        });
    }
}

export default new ProfileService();
